import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectLadCameraCoverageFeatures } from '@redux/mapDisplay/mapDisplay.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

import { ladCameraAzimuthLayer, ladCameraSectorLayer, ladCameraSectorOutlineLayer } from './ladCameraCoverage.layer';

function LadCameraCoverageLayerContent() {
  const ladCameraFeatures = useSelectorWithReplayMode(selectLadCameraCoverageFeatures);
  if (!isFeatureCollection(ladCameraFeatures)) return null;

  return (
    <Source id={SourceNameEnum.LAD_CAMERA_COVERAGES} type="geojson" data={ladCameraFeatures}>
      <Layer {...ladCameraSectorLayer} />
      <Layer {...ladCameraSectorOutlineLayer} />
      <Layer {...ladCameraAzimuthLayer} />
    </Source>
  );
}
export default function LadCameraCoverageLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.LAD_CAMERA_COVERAGES)}>
      <LadCameraCoverageLayerContent />
    </ErrorBoundary>
  ) : (
    <LadCameraCoverageLayerContent />
  );
}
